<div infiniteScroll [fromRoot]="true"
     [infiniteScrollContainer]="'mat-sidenav-content'"
     [infiniteScrollDistance]="2"
     (scrolled)="onScroll()">

  <div *ngFor="let user of (connectionUsers$ | async)">
    <anms-connection-user
      [userState]="user"
      [currentUser]="currentUser$ | async"
      (followUser)="followUser($event)"
      (unFollowUser)="unFollowUser($event)">
    </anms-connection-user>
  </div>

  <div *ngIf="(connectionUsers$ | async).length <= 0 && !(connectionLoading$ | async) && !(connectionError$ | async)">

    <div class="mt-4 mb-4" *ngIf="showFollowersEmptyView">
      <img class="w-50 h-50 img-fluid  mx-auto d-block" src="../../../../assets/images/states/no-followers.svg" alt="">
      <h6 class="text-muted text-center p-3">{{emptyStateMessage}}</h6>
    </div>

    <div class="mt-4 mb-4" *ngIf="showSearchEmptyView">
      <img class="w-50 h-50 img-fluid  mx-auto d-block" src="../../../../assets/images/states/no-users.svg" alt="">
      <h6 class="text-muted text-center p-3">No users found</h6>
    </div>
  </div>


  <div *ngIf="connectionError$ | async">
    <img class="w-75 img-fluid  mx-auto d-block" src="../../../../assets/images/states/no-users.svg">
    <h6 class="text-center py-2">An error occurred while fetching content!</h6>
    <div class="d-flex justify-content-center">
      <button mat-button routerLink="/home" color="primary">
        Home
        <mat-icon class="small-home">home</mat-icon>
      </button>
      <button mat-button routerLink="/discover" color="accent" class="mx-3">
        Disvover
        <mat-icon>face</mat-icon>
      </button>
      <button mat-button routerLink="/search" color="warn">
        Search
        <mat-icon>search</mat-icon>
      </button>
    </div>
    <br>
  </div>

  <div>
    <mat-progress-bar mode="query" *ngIf="connectionLoading$ | async" class="mb-5"></mat-progress-bar>
  </div>

</div>
